import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\ups-updated-2026\\components\\project\\ProjectList.jsx");
